
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.601 13.727v2.637a.81.81 0 01-.8.818.81.81 0 01-.801-.818V.818A.81.81 0 01.8 0a.81.81 0 01.801.818v6.546h18.727c1.769 0 3.203 1.465 3.203 3.272v5.728a.81.81 0 01-.801.818.81.81 0 01-.8-.818v-2.637H1.6zm0-1.636H21.93v-1.455c0-.903-.717-1.636-1.6-1.636H1.6v3.09zM4 5.875a.875.875 0 110-1.75h3a.875.875 0 110 1.75H4z","fill":"#fff","fill-rule":"nonzero"}})])
          )
        }
      }
    